import React from 'react';

import styled from 'styled-components';

import BaseCalendarIcon from '@edna/icons/calendar.svg';

import {TCalendarType} from '../Calendar';
import {Head as BaseDropdownHead, Overlay as BaseOverlay} from '../Dropdown';
import BaseTextInput from '../TextInput';
import {TInputProps as TMixinsInputProps, mixins} from '../styles';
import {DEFAULT_WIDTH} from './types';

type TDatePicker = {
  minWidth: string;
};

export const DatePicker = styled.div<TDatePicker>`
  min-width: ${({minWidth}) => minWidth};
  outline: none;
  border: none;
`;

export const CalendarIcon = styled(BaseCalendarIcon)<{disabled?: boolean}>`
  ${mixins.wh('16px')}
  color: ${({disabled, theme}) => (disabled ? theme.branding.colors.disabled : 'currentColor')};
`;

type TInputProps = React.InputHTMLAttributes<HTMLInputElement> & TMixinsInputProps;

export const DateInput = styled.div<TInputProps>`
  ${mixins.input};
  ${mixins.f3};
  display: flex;
  flex-direction: row;
  width: 100%;
  line-height: 20px;
  padding-left: 36px;
  cursor: ${({disabled}) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const DateSection = styled.input<{hasValue?: boolean; disabled?: boolean}>`
  flex-shrink: 0;
  width: 100%;
  cursor: ${({disabled}) => (disabled ? 'not-allowed' : 'text')};
  padding: 0;
  background-color: transparent;
  outline: none;
  border: none;
`;

export const Arrow = styled.div`
  ${mixins.stack({align: 'center', justify: 'center'})};
  flex-shrink: 0;
  align-self: center;
  width: 24px;
  color: ${({theme}) => theme.palette.grey400};
  margin-right: 1ch;
  margin-bottom: 2px;
`;

export const TextInput = styled(BaseTextInput)<{calendarType: TCalendarType}>`
  width: ${({calendarType}) => DEFAULT_WIDTH[calendarType]};
  min-width: ${({calendarType}) => DEFAULT_WIDTH[calendarType]};
  cursor: pointer;
`;

export const Overlay = styled(BaseOverlay)`
  box-shadow: ${({theme}) => theme.boxShadow.XS};
  border-radius: ${({theme}) => theme.borderRadius.br2};
`;

export const DropdownHead = styled(BaseDropdownHead)`
  cursor: default;
`;
